/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect} from 'react';
// redux
import {useSelector} from 'react-redux';
// material
import {ListSelectDropDown} from '@insticator/insticator-ui';

// utils
import {transpileDataForFilters} from '../../../../../../utils/transpilers/transpileDataForFilters';
import {getSiteAndAppFilterName} from "../../../../../../utils/filterhelpers";

// consts
import {FILTERS, SITES} from "../../consts";





/* ========== ~~~~~~~~~~ SITE FILTER ~~~~~~~~~~ ========== */

export default (props) => {
    // component props
    const {handleOnChange, filterValues} = props;

    // redux state
    const sitesAndApps = useSelector((state) => state.account.sitesAndApps)
    const items = transpileDataForFilters(sitesAndApps, true, true);
    const selected = (filterValues[SITES] || []).length ?
        items.filter((item) => filterValues[SITES].includes(item.value)).reduce((acc, item) => {
            if (acc[item.type]) acc[item.type].push(item.value);
            else acc[item.type] = [item.value];
            return acc;
        },{}) : null;
    const selectedSites = useSelector((state) => state.app.filters.sites)
    const selectedSitesByType = useSelector((state) => state.app.filters.sitesByType)

    return (
        <ListSelectDropDown
            klass={`filter-site`}
            name={'Domain/App'}
            items={items}
            selected={selected ? selected : (selectedSites.length ? selectedSitesByType : null)}
            noEmptyApply={true}
            buttonAction={
                sitesAndApps => {
                    let newValue = {...filterValues}
                    newValue[SITES] = Object.values(sitesAndApps).flat()
                    handleOnChange({[FILTERS]: newValue})
                }
            }
        />

    );
};
